import React from "react";
import PanelSegmentButton from "./PanelSegmentButton";
import PanelSegmentHeader from "./PanelSegmentHeader";
import PanelSegmentTitle from "./PanelSegmentTitle";
import PanelSegmentButtonBar from "./PanelSegmentButtonBar";
import PanelSegmentSupportQuestionMark from "./PanelSegmentQuestionMark";
import PanelSegmentPagination from "./PanelSegmentPagination";

interface Props {
  className?: string
  id?: string
}

type PanelSegmentType = React.FC<React.PropsWithChildren<Props>>;

interface PanelSegmentComponent extends PanelSegmentType {
  Header: typeof PanelSegmentHeader
  Title: typeof PanelSegmentTitle
  Button: typeof PanelSegmentButton
  ButtonBar: typeof PanelSegmentButtonBar
  SupportQuestionMark: typeof PanelSegmentSupportQuestionMark
  Pagination: typeof PanelSegmentPagination
}

const PanelSegment: PanelSegmentComponent = (props: React.PropsWithChildren<Props>) => {
  return <div id={props.id} className={props.className}>
    {props.children}
  </div>;
};

PanelSegment.Header = PanelSegmentHeader;
PanelSegment.Title = PanelSegmentTitle;
PanelSegment.Button = PanelSegmentButton;
PanelSegment.ButtonBar = PanelSegmentButtonBar;
PanelSegment.Pagination = PanelSegmentPagination;
PanelSegment.SupportQuestionMark = PanelSegmentSupportQuestionMark;

export default PanelSegment;